import React__default from 'react';
import classnames from 'classnames';
import { CLDeliveryIntervalSelect } from '../CLDeliveryIntervalSelect/CLDeliveryIntervalSelect.js';
import { CLPrescriptionSelectorContainer } from '../CLPrescriptionSelector/CLPrescriptionSelectorContainer.js';

const ContactLensesSubscriptionPurchase = ({ className  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classnames('contact-lenses-subscription-purchase', className)
    }, /*#__PURE__*/ React__default.createElement(CLDeliveryIntervalSelect, {
        className: "contact-lenses-subscription-purchase__delivery-interval"
    }), /*#__PURE__*/ React__default.createElement(CLPrescriptionSelectorContainer, null))
;

export { ContactLensesSubscriptionPurchase };
//# sourceMappingURL=ContactLensesSubscriptionPurchase.js.map
